import { useEffect, useCallback } from 'react';
import { saveGameSession, loadGameSession, clearGameSession } from '../utils/storage';

/**
 * Custom hook for game session management
 * Auto-saves game state every 10 seconds during gameplay
 */
export function useGameSession(gameState, sessionData) {
  // Auto-save game session every 10 seconds when playing
  useEffect(() => {
    if (gameState === 'playing' && sessionData) {
      const interval = setInterval(() => {
        saveGameSession(sessionData);
      }, 10000); // Save every 10 seconds

      return () => clearInterval(interval);
    }
  }, [gameState, sessionData]);

  // Save session when leaving the page
  useEffect(() => {
    const handleBeforeUnload = () => {
      if (gameState === 'playing' && sessionData) {
        saveGameSession(sessionData);
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [gameState, sessionData]);

  // Get saved session
  const getSavedSession = useCallback(() => {
    return loadGameSession();
  }, []);

  // Clear saved session
  const clearSession = useCallback(() => {
    clearGameSession();
  }, []);

  return {
    getSavedSession,
    clearSession,
  };
}
